// gloss
export type StepRailState = 'done' | 'current' | 'ahead';

export type StepRailTone = 'primary' | 'success' | 'warning' | 'destructive' | 'default';

export type StepRailTile = { tone: StepRailTone; fill: 'solid' | 'tinted' };

// gloss
export const getStepRailTile = (state: StepRailState, tone: StepRailTone = 'primary'): StepRailTile => {
  if (state === 'ahead') return { tone: 'default', fill: 'tinted' };
  return { tone, fill: state === 'done' ? 'solid' : 'tinted' };
};

// gloss
export const stepRailLabelColors = {
  active: 'text-foreground',
  ahead: 'text-muted-foreground',
} as const;

export const stepRailConnectorColors = {
  filled: 'bg-primary',
  pending: 'bg-border',
} as const;
